import { useContext } from 'react';
import { CartContext } from '../context/CartContext/CartContext';

export const useCart = () => {
  const contextValue = useContext(CartContext);

  return contextValue;
};
